import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetXY,
  xBand,
  yLinear,
  initColumnParallel,
  columnAnimation,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  pivotIndicators,
  initPivot,
  datasetPivot,
  pivotAdapter,
  pivotDiscreteLegend,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  columnStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
  verticalCrosshairRect,
  barCornerRadius,
  progressive,
  linearColor,
  colorAdapter,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  barMaxWidth,
  barGapInGroup,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const columnParallel: VChartSpecPipeline = [
  fontFamilyTheme,
  initColumnParallel,
  columnAnimation,
  regionPadding,
  barCornerRadius,
  barMaxWidth,
  barGapInGroup,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  xBand,
  yLinear,
  label,
  brush,
  tooltip({ titleEncoding: 'x' }),
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairRect,
  colorBarStyleFill(columnStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationDifferenceLine,
  annotationAreaBand,
]

const pivotColumnParallel: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initColumnParallel,
    columnAnimation,
    regionPadding,
    barCornerRadius,
    barMaxWidth,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    xBand,
    pivotAxisStyle(yLinear),
    brush,
    label,
    tooltip({ titleEncoding: 'x' }),
    verticalCrosshairRect,
    colorBarStyleFill(columnStyle),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationDifferenceLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const columnParallelSpecPipeline = [pivotAdapter(columnParallel, pivotColumnParallel)]
